import { render, staticRenderFns } from "./SelectShip.vue?vue&type=template&id=197a6c36&scoped=true"
import script from "./SelectShip.vue?vue&type=script&lang=js"
export * from "./SelectShip.vue?vue&type=script&lang=js"
import style0 from "./SelectShip.vue?vue&type=style&index=0&id=197a6c36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197a6c36",
  null
  
)

export default component.exports